module.exports = __webpack_public_path__ + "img/img60.bcdbc859.png";